import {
  Button,
  Container,
  FormControl,
  Grid,
  InputLabel,
  Paper,
  Select,
  Snackbar,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";

import axios from "axios";
import React, { Component } from "react";
import Modal from "react-awesome-modal";
import { Card, CardBody, Col, Row } from "reactstrap";
import Constants from "../Variables/Constants";
import init from "../../helpers/WindowToken";

export default class WebEnquiries extends Component {
  state = {
    enquiries: [],
    visible: false,
    rowId: "",
    notifyDelete: false,
    notifyStatus: false,
    delLoading: false,
    page: 1,
    limit: 10,
    total: 0,
    nextPage: false,
    prevPage: false,
    requestError: "",
  };

  componentDidMount() {
    this.fetchEnquiries();
  }

  handleRequestError = (error, fallbackState = {}) => {
    this.setState({
      ...fallbackState,
      delLoading: false,
      requestError:
        error?.response?.data?.message ||
        error?.message ||
        "Failed to process web enquiries",
    });
  };

  /* FETCH ENQUIRIES */

  fetchEnquiries = () => {
    axios
      .get(
        `${Constants.getUrls.getenquiryList}?page=${this.state.page}&limit=${this.state.limit}`,
      )
      .then((res) => {
        this.setState({
          enquiries: res.data.data.docs,
          total: res.data.pagination?.totalDocs || 0,
          nextPage: res.data.pagination?.hasNextPage,
          prevPage: res.data.pagination?.hasPrevPage,
          requestError: "",
        });
      })
      .catch((error) => {
        this.handleRequestError(error, {
          enquiries: [],
          total: 0,
          nextPage: false,
          prevPage: false,
        });
      });
  };

  /* DELETE */

  handleModal = (row) => {
    this.setState({
      rowId: row._id,
      visible: true,
    });
  };

  handleDelete = () => {
    this.setState({ delLoading: true });

    axios
      .delete(Constants.deleteUrls.deletWebEnquiry + this.state.rowId)
      .then(() => {
        this.setState({
          notifyDelete: true,
          delLoading: false,
          visible: false,
        });

        this.fetchEnquiries();
      })
      .catch((error) => {
        this.handleRequestError(error, { visible: false });
      });
  };

  /* MARK AS READ SWITCH */

  handleToggleRead = (row) => {
    const newValue = row.marked_as_read === "yes" ? "no" : "yes";

    axios
      .post(Constants.postUrls.markEnquiryAsRead + "/" + row._id, {
        marked_as_read: newValue,
      })
      .then(() => {
        this.setState({ notifyStatus: true });

        this.fetchEnquiries();

        setTimeout(() => {
          this.setState({ notifyStatus: false });
        }, 1500);
      })
      .catch((error) => {
        this.handleRequestError(error);
      });
  };

  /* PAGINATION */

  handleNext = () => {
    this.setState((prev) => ({ page: prev.page + 1 }), this.fetchEnquiries);
  };

  handlePrev = () => {
    this.setState((prev) => ({ page: prev.page - 1 }), this.fetchEnquiries);
  };

  handleLimitChange = (e) => {
    this.setState(
      {
        limit: e.target.value,
        page: 1,
      },
      this.fetchEnquiries,
    );
  };

  render() {
    return (
      <Container maxWidth="xl">
        <Snackbar
          open={Boolean(this.state.requestError)}
          autoHideDuration={4000}
          onClose={() => this.setState({ requestError: "" })}
          message={this.state.requestError}
        />
        {/* SNACKBARS */}

        {this.state.notifyDelete && (
          <Snackbar open message="Deleted Successfully" />
        )}

        {this.state.notifyStatus && <Snackbar open message="Status Updated" />}

        {/* HEADER */}

        <Grid container alignItems="center">
          <Grid item xs={6}>
            <Typography variant="h6">Web Enquiries</Typography>
          </Grid>
        </Grid>

        <br />

        {/* TABLE */}

        <Paper>
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>S.No</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Phone</TableCell>
                  <TableCell>Message</TableCell>
                  <TableCell>Image</TableCell>
                  <TableCell>Read</TableCell>
                  <TableCell align="right">Action</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {this.state.enquiries.map((row, i) => (
                  <TableRow key={row._id}>
                    <TableCell>{i + 1}</TableCell>

                    <TableCell>{row.name}</TableCell>

                    <TableCell>{row.email}</TableCell>

                    <TableCell>{row.phone}</TableCell>

                    <TableCell
                      style={{
                        maxWidth: "360px",
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-word",
                        lineHeight: 1.5,
                      }}
                    >
                      {row.message}
                    </TableCell>

                    {/* IMAGE */}

                    <TableCell>
                      {row.image ? (
                        <a
                          href={Constants.imgDomain + row.image}
                          download
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={Constants.imgDomain + row.image}
                            alt=""
                            style={{
                              height: "60px",
                              width: "60px",
                              objectFit: "cover",
                              borderRadius: "4px",
                              transition: "0.3s",
                              cursor: "pointer",
                            }}
                            onMouseOver={(e) => {
                              e.target.style.transform = "scale(2)";
                              e.target.style.zIndex = "10";
                            }}
                            onMouseOut={(e) => {
                              e.target.style.transform = "scale(1)";
                            }}
                          />
                        </a>
                      ) : (
                        <Typography color="textSecondary">No Image</Typography>
                      )}
                    </TableCell>

                    {/* SWITCH */}

                    <TableCell>
                      <Switch
                        checked={row.marked_as_read === "yes"}
                        onChange={() => this.handleToggleRead(row)}
                        color="primary"
                      />
                    </TableCell>

                    {/* ACTION */}

                    <TableCell align="right">
                      <Button
                        variant="outlined"
                        color="secondary"
                        size="small"
                        onClick={() => this.handleModal(row)}
                      >
                        Delete
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>

            {/* PAGINATION */}

            <TableRow
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div>
                Showing {this.state.enquiries.length} of {this.state.total}
              </div>

              <div>
                <FormControl>
                  <InputLabel />

                  <Select
                    native
                    value={this.state.limit}
                    onChange={this.handleLimitChange}
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                  </Select>
                </FormControl>
              </div>

              <div>
                <Button
                  disabled={!this.state.prevPage}
                  onClick={this.handlePrev}
                >
                  Previous
                </Button>

                <Button
                  disabled={!this.state.nextPage}
                  onClick={this.handleNext}
                >
                  Next
                </Button>
              </div>
            </TableRow>
          </TableContainer>
        </Paper>

        {/* DELETE MODAL */}

        <Modal
          visible={this.state.visible}
          width="400"
          height="150"
          effect="fadeInUp"
          onClickAway={() => this.setState({ visible: false })}
        >
          <Card>
            <CardBody>
              <Typography>Are you sure you want to delete?</Typography>

              <Button
                color="secondary"
                variant="contained"
                onClick={this.handleDelete}
              >
                Yes
              </Button>

              <Button
                color="primary"
                variant="contained"
                onClick={() => this.setState({ visible: false })}
              >
                No
              </Button>
            </CardBody>
          </Card>
        </Modal>
      </Container>
    );
  }
}
